<template>
  <div class="editor d-flex flex-column flex-fill">
    <div v-if="editor && editable" class="toolbar flex-column flex-sm-row">
      <div class="d-flex">
        <button
          class="toolbar-item"
          :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
          title="Heading 2"
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 2 })
              .run()
          "
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-type-h3" viewBox="0 0 24 24">
            <path
              d="M9 7h2v10H9v-4H5v4H3V7h2v4h4V7zm8 8c.51-.41.6-.62 1.06-1.05c.437-.4.848-.828 1.23-1.28a6.4 6.4 0 0 0 .85-1.28c.199-.39.305-.822.31-1.26a3.007 3.007 0 0 0-.27-1.28a2.902 2.902 0 0 0-.76-1a3.485 3.485 0 0 0-1.17-.63a4.766 4.766 0 0 0-1.5-.22c-.359 0-.717.033-1.07.1a4.895 4.895 0 0 0-1 .29a4.431 4.431 0 0 0-.86.49c-.287.21-.561.437-.82.68l1.24 1.22a5.829 5.829 0 0 1 1-.7c.35-.201.747-.304 1.15-.3a1.91 1.91 0 0 1 1.27.38c.311.278.477.684.45 1.1a2.127 2.127 0 0 1-.36 1.11a7.126 7.126 0 0 1-1 1.25c-.44.43-.98.92-1.59 1.43c-.61.51-1.41 1.06-2.16 1.65V17h8v-2h-4z"
              fill="currentColor"
            />
          </svg>
        </button>
        <button
          class="toolbar-item"
          :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
          title="Heading 3"
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 3 })
              .run()
          "
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-type-h3" viewBox="0 0 24 24">
            <path
              d="M14.11 14.218c.355.287.749.523 1.17.7c.434.181.9.273 1.37.27c.484.017.965-.086 1.4-.3a.92.92 0 0 0 .55-.84a1.136 1.136 0 0 0-.15-.58a1.137 1.137 0 0 0-.51-.43a3.65 3.65 0 0 0-1-.27a9.786 9.786 0 0 0-1.52-.1v-1.57a4.73 4.73 0 0 0 2.17-.36a1.06 1.06 0 0 0 .63-.93a.9.9 0 0 0-.38-.81a2.002 2.002 0 0 0-1.13-.28a2.836 2.836 0 0 0-1.14.28a5.568 5.568 0 0 0-1.06.62l-1.22-1.39a6.55 6.55 0 0 1 1.64-.9a5.354 5.354 0 0 1 1.9-.33a6.448 6.448 0 0 1 1.56.17c.431.101.84.277 1.21.52c.325.211.595.495.79.83c.19.342.287.729.28 1.12c.011.48-.177.943-.52 1.28a3.867 3.867 0 0 1-1.46.86v.06c.609.14 1.175.425 1.65.83c.437.382.68.94.66 1.52c.005.421-.113.835-.34 1.19a2.853 2.853 0 0 1-.9.88a4.462 4.462 0 0 1-1.32.55a6.395 6.395 0 0 1-1.57.19a6.42 6.42 0 0 1-2.31-.37a4.29 4.29 0 0 1-1.57-1l1.12-1.41zM9 11H5V7H3v10h2v-4h4v4h2V7H9v4z"
              fill="currentColor"
            />
          </svg>
        </button>
        <button
          class="toolbar-item"
          :class="{ 'is-active': editor.isActive('heading', { level: 4 }) }"
          title="Heading 4"
          @click="
            editor
              .chain()
              .focus()
              .toggleHeading({ level: 4 })
              .run()
          "
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path d="M11 17H9v-4H5v4H3V7h2v4h4V7h2v10zm10-2h-1v2h-2v-2h-5v-2l4.05-6H20v6h1v2zm-3-2V9l-2.79 4H18z" fill="currentColor" />
          </svg>
        </button>
        <button
          class="toolbar-item"
          :class="{ 'is-active': editor.isActive('paragraph') }"
          title="Paragraph"
          @click="
            editor
              .chain()
              .focus()
              .setParagraph()
              .run()
          "
        >
          <i class="fas fa-paragraph"></i>
        </button>
        <button class="toolbar-item" :class="{ 'is-active': editor.isActive('link') }" @click="link">
          <template v-if="editor.isActive('link')">
            <i class="fas fa-unlink"></i>
          </template>
          <template v-else>
            <i class="fas fa-link"></i>
          </template>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <span class="px-2">Aantal woorden: {{ words }}</span>
        <button
          class="toolbar-item"
          :disabled="!editor.can().undo()"
          :class="{ 'is-disabled': !editor.can().undo() }"
          title="Undo"
          @click="
            editor
              .chain()
              .focus()
              .undo()
              .run()
          "
        >
          <i class="fas fa-undo"></i>
        </button>
        <button
          class="toolbar-item"
          :disabled="!editor.can().redo()"
          :class="{ 'is-disabled': !editor.can().redo() }"
          title="Redo"
          @click="
            editor
              .chain()
              .focus()
              .redo()
              .run()
          "
        >
          <i class="fas fa-redo"></i>
        </button>
      </div>
    </div>
    <editor-content :editor="editor" class="flex-fill" ref="editor" />
    <div class="modal fade" ref="linkModal" id="linkModal" tabindex="-1" aria-labelledby="linkModalLink" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="block block-rounded block-transparent mb-0">
            <div class="block-header block-header-default">
              <h3 class="block-title">Link plaatsen</h3>
            </div>
            <div class="block-content fs-sm mb-4">
              <bs-input label="Link" name="link" v-model="selectedUrl" :disabled="!canPlaceLink"></bs-input>
            </div>
            <div class="block-content block-content-full text-right bg-body">
              <button type="button" class="btn btn-sm btn-danger" @click="removeLink">Verwijder link</button>
              <button type="button" class="btn btn-sm btn-primary" :disabled="!canPlaceLink" @click="setLink">Plaats link</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Editor, EditorContent } from '@tiptap/vue-2';
import CharacterCount from '@tiptap/extension-character-count';
import Document from '@tiptap/extension-document';
import Heading from '@tiptap/extension-heading';
import History from '@tiptap/extension-history';
import Link from '@tiptap/extension-link';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';

export default {
  name: 'bs-editor',
  components: {
    EditorContent,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      editor: null,
      selectedUrl: null,
    };
  },
  computed: {
    canPlaceLink: function() {
      if (!this.editor || !this.editor.view.state.selection) return true;
      return this.editor.view.state.selection.$to.pos - this.editor.view.state.selection.$from.pos <= 42;
    },
    errors: function() {
      if (this.canPlaceLink) return;

      return {
        link: ['Het is niet mogelijk een link toe te voegen. Anchor mag maximaal 42 tekens bevatten.'],
      };
    },
    words: function() {
      return this.editor && this.editor.getText().trim().length >= 1
        ? this.editor
            .getText()
            .trim()
            .split(/\s+/).length
        : 0;
    },
  },
  watch: {
    value(value) {
      const isSame = this.editor.getHTML() === value;
      if (isSame) {
        return;
      }

      this.editor.commands.setContent(value, false);
    },
  },
  mounted() {
    this.editor = new Editor({
      content: this.value,
      editable: this.editable,
      onUpdate: () => {
        this.$emit('input', this.editor.getHTML());
      },
      injectCSS: false,
      extensions: [
        Document,
        Paragraph,
        Text,
        Heading.configure({
          levels: [2, 3, 4],
        }),
        Link.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
            rel: null,
          },
        }),
        History,
        CharacterCount,
      ],
    });
  },

  methods: {
    link() {
      const previousUrl = this.editor.getAttributes('link').href;
      this.selectedUrl = previousUrl;

      $(this.$refs.linkModal).modal('toggle');
    },
    removeLink() {
      this.selectedUrl = null;
      this.setLink();
    },
    setLink() {
      // empty field
      if (!this.selectedUrl) {
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .unsetLink()
          .run();
      } else {
        const { view, state } = this.editor;
        let { from, to } = view.state.selection;
        const text = state.doc.textBetween(from, to, ' ');

        if (text[0] === ' ') {
          from++;
        }

        if (text.slice(-1) === ' ') {
          to--;
        }

        // update link
        this.editor.commands.setTextSelection({from: from, to: to });
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .setLink({ href: this.selectedUrl })
          .run();
      }

      $(this.$refs.linkModal).modal('hide');
    },
  },

  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>
<style lang="scss">
@import '@/../sass/_variables';

.editor {
  border: 1px solid #e1e1e1;

  .toolbar {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e1e1e1;

    .toolbar-item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 32px;
      background: white;
      color: inherit;
      border: none;
      margin: 5px;
      cursor: pointer;
      transition: all 0.05s ease;

      &:focus {
        outline-color: $primary;
      }

      &.is-active,
      &:hover {
        background: rgba($primary, $alpha: 0.25);
        color: $primary;
      }

      &.is-disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
  }

  /* Basic editor styles */
  .ProseMirror {
    min-height: 350px;
    height: 100%;
    padding: 0.375rem 0.75rem;
    text-align: initial;
    overflow-y: auto;
    overflow-x: hidden;
    white-space: pre-wrap;

    &:focus {
      outline: none;
    }

    &[contenteditable="false"] {
      background-color: #e9ecef;
    }

    a {
      text-decoration: underline;
    }
  }
}
</style>
